import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { ContractDetails, MijnOverzichtResource } from '@ap/interface-apix-mijn-overzicht';

@Injectable({ providedIn: 'root' })
export class BusinessCustomerService {
    private businessCustomer: boolean;
    private selfEmployed: boolean;

    private readonly mijnOverzichtResource: MijnOverzichtResource = inject(MijnOverzichtResource);

    public isBusinessCustomer(): Observable<boolean> {
        if (this.businessCustomer !== undefined) {
            return of(this.businessCustomer);
        }

        return this.mijnOverzichtResource.getContractDetails().pipe(
            tap((contractDetails) => {
                this.setCustomerDetails(contractDetails);
            }),
            map(() => {
                return this.businessCustomer;
            }),
            catchError(() => {
                this.businessCustomer = false;
                this.selfEmployed = false;
                return of(false);
            })
        );
    }

    public isBusiness(): boolean {
        return this.businessCustomer;
    }
    public isSelfEmployed(): boolean {
        return this.selfEmployed;
    }

    private setCustomerDetails(details: ContractDetails): void {
        this.businessCustomer = details.is_zakelijk;
        this.selfEmployed = details.is_zzp;
    }
}
